import { useIntl } from '@leagueplatform/locales';

export const useRequiredErrorMessage = (label?: string) => {
  const { formatMessage } = useIntl();
  return label
    ? formatMessage({ id: 'STR_REQUIRED_FIELD' }, { fieldName: label })
    : '';
};
